import React from "react";
import DashboardBlockA from "./DashboardBlockA";
import DashboardBlockB from "./DashboardBlockB";
import DashboardBlockC from "./DashboardBlockC";
import DashboardBlockD from "./DashboardBlockD";

import "./styles.css";

const DashboardMain = ({ equityData, matrixAssetData, topGainerLossers }) => {
  const metrics = matrixAssetData?.metrics[0];

  const blockAConfig = [
    {
      title: "Total Investment",
      value: metrics
        ? Math.abs(metrics?.total_investment_value).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
          })
        : null,
    },
    {
      title: "Current Value",
      value: metrics
        ? Number(metrics?.current_value).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
          })
        : null,
    },
    {
      title: "Realized Profit/Loss",
      value: metrics
        ? Number(metrics?.realized_profit_loss_value).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
          })
        : null,
    },
    {
      title: "Notional Profit/Loss",
      value: metrics
        ? Number(metrics?.notional_profit_loss_value).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
          })
        : null,
    },
  ];

  return (
    <div className=" dashboard-layout mt-4 text-neutral-800 md:grid [&>div]:rounded-md [&>div]:bg-white [&>div]:p-4 [&>div]:shadow-sm max-sm:[&>div]:mt-4">
      <span className="max-md:flex max-md:flex-wrap max-md:justify-between md:space-y-7 [&>div]:rounded-md [&>div]:bg-white [&>div]:shadow-sm max-md:[&>div]:p-4 md:[&>div]:p-4">
        {blockAConfig.map((block, idx) => (
          <div
            key={idx}
            className="row-span-1 h-fit w-full flex-col justify-between max-md:mb-[1rem] max-md:w-[48%] md:mr-[2rem] md:flex"
          >
            <DashboardBlockA block={block} />
          </div>
        ))}
      </span>

      <div className="col-span-2 col-start-2 row-span-2 row-start-1 ">
        <DashboardBlockB
          assetSegmentData={matrixAssetData?.asset_segment[0]}
          assetNatureData={matrixAssetData?.trade_nature[0]}
        />
      </div>

      <div className="col-span-3 col-start-4 row-span-2 row-start-1 ">
        <DashboardBlockC equityData={equityData} />
      </div>

      <div className="col-span-5 col-start-2 row-span-2 row-start-3 ">
        <DashboardBlockD topGainerLossers={topGainerLossers} />
      </div>
    </div>
  );
};

export default DashboardMain;
